import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const PaddingContainer = withViewportStyle("div")`
  padding: ${rem(80)} ${rem(24)};

  ${(props) => props.$viewport.tablet`
    padding: ${rem(60)} ${rem(20)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;

export const Wrapper = withViewportStyle("div")`
  grid-area: heading;
  margin-bottom: ${rem(40)};

  ${(props) => props.$viewport.tablet`
    margin-bottom: ${rem(32)};
  `}

  ${(props) => props.$viewport.mobile`
    margin-bottom: ${rem(24)};
  `}
`;
